import React from "react";
import { GenericCrud, useFetch, StatusBadge } from "@/components/common";

const CATS = ["U8", "U9", "U10", "U11", "U12", "U13", "U14", "U15"];

export default function Teams() {
  const { data: coaches } = useFetch("/users", []);
  const coachOpts = (coaches || []).filter((u) => ["coach", "assistant_coach"].includes(u.role)).map((c) => ({ value: c.id, label: c.name }));
  const coachName = (id) => (coaches || []).find((c) => c.id === id)?.name || "—";

  return (
    <GenericCrud
      title="Teams" subtitle="Manage teams and categories" endpoint="/teams" testid="teams"
      columns={[
        { key: "name", label: "Team" },
        { key: "category", label: "Category", render: (r) => <StatusBadge status={r.category} /> },
        { key: "coach", label: "Coach", render: (r) => coachName(r.coach_id) },
        { key: "field", label: "Field" },
        { key: "player_count", label: "Players", render: (r) => <span className="font-semibold">{r.player_count}</span> },
      ]}
      fields={[
        { key: "name", label: "Team Name", full: true },
        { key: "category", label: "Category", type: "select", options: CATS.map((c) => ({ value: c, label: c })) },
        { key: "field", label: "Field / Stadium" },
        { key: "coach_id", label: "Coach", type: "select", options: coachOpts },
        { key: "assistant_coach_id", label: "Assistant Coach", type: "select", options: coachOpts },
        { key: "training_schedule", label: "Training Schedule", full: true },
      ]}
    />
  );
}
